export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--6.e81eda3b.png";